import Loaders from "react-spinners/BeatLoader";

export default function Loader() {

  return (
    <div className="spinner">
      <h1>Loading</h1>
      <Loaders />
    </div>

  )


}